import { API, getToken } from "../util/auth";

const buildHeaders = () => {
  const token = getToken();
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
};

export async function changePassword(currentPassword: string, newPassword: string) {
  const res = await fetch(`${API}/change-password`, {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify({
      current_password: currentPassword,
      new_password: newPassword,
    }),
  });

  if (!res.ok) {
    let message = "Failed to change password.";
    try {
      const payload = await res.json();
      message = payload.detail || payload.msg || message;
    } catch {
      // noop
    }
    throw new Error(message);
  }

  return res.json() as Promise<{
    msg: string;
    access_token?: string;
    token_type?: string;
  }>;
}
